import { languages, getLocaleKey } from '@constants'

export default {
  install(Vue) {
    Vue.prototype.$t = function (key, values, file) {
      let lang
      if (languages.enums.find(l => l.value === this.$route.params.lang)){
        lang = this.$route.params.lang
      } else {
        lang = languages.get(getLocaleKey()).value
      }
      let _text
      if (!file){
        _text = this.$options.$messages[lang][key]
      } else {
        _text = this.$options.$messages[file][lang][key]
      }

      for (const i in values) {
        const reg = new RegExp(`{{${i}}}`, 'g')
        if (reg.test(_text)) {
          _text = _text.replace(reg, values[i])
        }
      }
      return _text
    }
  }
}
